import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { faqItems } from "@/mocks/homeData";
import JsonLD from "@/components/base/JsonLD";
import { faqSchema } from "@/components/base/PageSchemas";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function FaqPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLD data={faqSchema} />
      <Navbar />
      <main>
        <section className="pt-24 md:pt-32 pb-10 md:pb-14 bg-background-50">
          <div className="mx-auto max-w-[1440px] px-4 text-center md:px-8 lg:px-16 xl:px-20">
            <Breadcrumb />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent-500 mb-3 block">FAQ</span>
            <h1 className="mx-auto max-w-3xl font-heading text-3xl text-foreground-950 md:text-4xl lg:text-5xl">
              Najczęściej zadawane pytania
            </h1>
          </div>
        </section>

        <section className="pb-16 md:pb-24">
          <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
            <div className="mx-auto max-w-4xl">
              <div className="flex flex-col gap-3">
                {faqItems.map((item, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-xl border border-background-200/60 overflow-hidden"
                  >
                    <button
                      onClick={() => setOpenIndex(openIndex === index ? null : index)}
                      className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                    >
                      <span className="font-heading text-sm md:text-base font-semibold text-foreground-800">
                        {item.question}
                      </span>
                      <div className={`w-8 h-8 flex items-center justify-center rounded-full bg-background-100 shrink-0 transition-transform ${openIndex === index ? "rotate-180" : ""}`}>
                        <i className="ri-arrow-down-s-line text-foreground-500" />
                      </div>
                    </button>
                    {openIndex === index && (
                      <div className="px-5 md:px-6 pb-5">
                        <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                          {item.answer}
                        </p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
